import {
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LicensesService extends HttpService {

  constructor(private httpClient: HttpClient, public injector: Injector) {
    super(httpClient);
  }

  /**
   * Fetch licenses for a specific building by its project ID.
   * @param projectId - The ID of the Project.
   * @returns Observable containing the licenses data.
   */
  public getBuildingLicenses(
    projectId: string,
    accessToken: string
  ): Observable<Object> {
  let endPoint = `${environment.gateway_endpoint}/api/v1/buildings`;
    const url = `${endPoint}/${projectId}/licenses`;
    let headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });
    return this.get<any[]>(url, null, headers);
  }
}
